{
  "accountManager": {
    "loadErrorText": "Kunne ikke laste kundeansvarlige",
    "description": "Fyll inn hvem som skal være kundeansvarlig for tømmerkjøperen",
    "label": "Kundeansvarlig",
    "placeholder": "Velg kundeansvarlig",
    "title": "Kundeansvarlig i {{tenantName}}"
  },
  "company": {
    "buyerNumber": {
      "createdOnCompletion": "Kjøpernummer opprettes ved fullføring"
    },
    "industry": {
      "loadErrorText": "Kunne ikke laste forretningsområder",
      "label": "Bransje",
      "placeholder": "Velg bransje"
    },
    "noOrganizationNumber": {
      "description": "Fiktivt organisasjonsnummer opprettes ved fullføring",
      "label": "Tømmerkjøper har ikke et organisasjonsnummer"
    },
    "organizationNumber": {
      "description": "Skriv inn organisasjonsnummer (9 siffer) eller et fiktivt nummer (NO+11 siffer)",
      "label": "Organisasjonsnummer",
      "errorFormat": "Organisasjonsnummer må være 9 siffer"
    },
    "organizationName": {
      "label": "Organisasjonsnavn",
      "error": "Skriv inn ett organisasjonsnummer eller huk av for at tømmerkjøper ikke har ett organisasjonsnummer"
    },
    "timberbuyerName": {
      "label": "Tømmerkjøpernavn"
    }
  },
  "contact": {
    "email": {
      "placeholder": "kontakt@eksempel.no",
      "description": "Eksempel: kontakt@tommerkjoper.no",
      "label": "E-post"
    },
    "description": "Registrer kontaktinformasjon til tømmerkjøper",
    "phone": {
      "description": "Eksempel: 91 23 45 67",
      "label": "Telefonnummer",
      "placeholder": "000 00 000"
    },
    "title": "Kontaktinformasjon"
  },
  "form": {
    "description": "Fyll inn informasjon om tømmerkjøper",
    "title": "Tømmerkjøperinformasjon"
  },
  "invoicing": {
    "email": {
      "placeholder": "faktura@eksempel.no",
      "description": "Eksempel: faktura@tommerkjoper.no",
      "label": "Faktura e-post",
      "errorRequired": "E-post er påkrevd når leveringsmetode er e-post"
    },
    "mailAlert": "Faktura sendes til fakturaadresse oppgitt ovenfor.",
    "address": {
      "description": "Eksempel: Tømmergata",
      "label": "Adresse"
    },
    "city": {
      "description": "Eksempel: Oslo",
      "label": "Sted"
    },
    "deliveryMethod": {
      "label": "Velg hvor tømmerkjøper ønsker å motta faktura",
      "options": {
        "email": "E-post",
        "mail": "Post (brev)"
      }
    },
    "description": "Registrer fakturainformasjon",
    "houseNumber": {
      "description": "Eksempel: 16C",
      "label": "Husnummer"
    },
    "postCode": {
      "description": "Eksempel: 0123",
      "label": "Postnummer"
    },
    "recipient": {
      "description": "Velg hvem som skal stå som mottaker",
      "label": "Hvem skal motta faktura?",
      "options": {
        "other": "Annen",
        "otherDescription": "Eksempel: Tømmerkjøper eller regnskapsfører",
        "timberBuyer": "Organisasjonen"
      }
    },
    "title": "Fakturainformasjon"
  },
  "summary": {
    "actions": {
      "register": "Registrer"
    },
    "description": "Sjekk at informasjonen stemmer før du lagrer",
    "error": {
      "description": "Det oppstod en feil ved registrering av tømmerkjøper. Prøv igjen.",
      "vsysBuyerRoleMissing": "Organisasjonen er ikke registrert som kjøper med riktig gruppe/type. Rett gruppe/type i Skogdata, og prøv igjen.",
      "vsysBuyerRoleMissingTitle": "Registreringen kunne ikke fullføres"
    },
    "fields": {
      "customerResponsible": "Kundeansvarlig i {{tenantName}}",
      "deliveryMethod": "Mottak av faktura",
      "email": "E-postadresse",
      "fictionalOrganizationNumberOnCompletion": "Fiktivt org.nummer opprettes ved fullføring",
      "industry": "Bransje",
      "invoiceAddress": "Adresse",
      "invoiceCountry": "Land",
      "invoiceEmail": "Faktura e-post",
      "invoiceRecipientName": "Mottaker",
      "measurementOrganization": "Måleorganisasjon",
      "organizationName": "Tømmerkjøpernavn",
      "organizationNumber": "Organisasjonsnummer",
      "phone": "Telefonnummer",
      "transportPayer": "Transportbruker",
      "transportResponsible": "Transportansvarlig",
      "vsysBuyerNumber": "Kjøpernummer"
    },
    "sections": {
      "accountManager": "Kundeansvarlig",
      "company": "Tømmerkjøperinformasjon",
      "contact": "Kontaktinformasjon",
      "invoicing": "Fakturainformasjon",
      "transport": "Transportinformasjon"
    },
    "title": "Oppsummering"
  },
  "title": "Registrer ny tømmerkjøper",
  "transport": {
    "measurementOrganization": {
      "loadErrorText": "Kunne ikke laste målingsorganisasjoner",
      "description": "Hvem som er ansvarlig for måling av virke?",
      "label": "Måleorganisasjon",
      "placeholder": "Velg måleorganisasjon"
    },
    "payer": {
      "loadErrorText": "Kunne ikke laste transportbetalere",
      "description": "Hvem er ansvarlig for transportkostnader?",
      "label": "Transportbruker",
      "placeholder": "Velg transportbruker"
    },
    "responsible": {
      "loadErrorText": "Kunne ikke laste transportansvarlige",
      "description": "Hvem administrerer transport av virke?",
      "label": "Transportansvarlig",
      "placeholder": "Velg transportansvarlig"
    },
    "description": "Registrer transportinformasjon",
    "title": "Transportinformasjon"
  },
  "vsys": {
    "addButton": "Legg til kjøpernummer",
    "dialog": {
      "createNewDescription": "Nytt kjøpernummer opprettes ved fullføring",
      "createNewLabel": "Jeg ønsker å opprettet ett nytt kjøpernummer knyttet til denne kunden",
      "description": "Velg hvilke kjøpernummer du ønsker å knytte til tømmerkjøperprofilen. Du kan bare velge ett kjøpernummer per profil",
      "emptyList": "Listen er tom",
      "errorDescription": "Kunne ikke hente kjøpernumre. Prøv igjen.",
      "errorTitle": "Feil ved henting av kjøpernumre",
      "goToProfile": "Gå til tømmerkjøperprofil",
      "inUseLabel": "Allerede i bruk",
      "inUseWarningDescription": "Er profilen inaktiv, kan du aktivere den for videre bruk.",
      "inUseWarningGeneric": "Kjøpernummeret er allerede knyttet til en tømmerkjøperprofil",
      "inUseWarningTitle": "Kjøpernummeret er allerede knyttet til tømmerkjøperprofilen {{name}}",
      "loading": "Henter kjøpernumre…",
      "missingOrgNumber": "Fyll inn organisasjonsnummer for å se tilgjengelige kjøpernumre, eller velg å opprette et nytt kjøpernummer.",
      "noneAvailable": "Det er ingen kjøpernummer tilgjengelig",
      "title": "Velg kjøpernummer"
    },
    "formDescription": "Legg til kjøpernummer du ønsker å knytte til industrikunden",
    "infoLabel": "Valgt kjøpernummer",
    "newOnSave": "Nytt kjøpernummer opprettes ved fullføring"
  }
}
